var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TicketList',{attrs:{"ticket":_vm.ticket,"title":"All User Ticket"}})
}
var staticRenderFns = []

export { render, staticRenderFns }